import { __assign } from "tslib";
export { getRealMaster };
function mockParams(alignments, paddings) {
    return {
        titleParams: __assign({ title: 'dummy from info.ts', 
            // @ts-ignore
            horizontalAlignment: alignments.Title }, paddingForInfoType('Title', paddings)),
        descriptionParams: __assign({ description: 'dummy_desc from info.ts', 
            // @ts-ignore
            horizontalAlignment: alignments.Description }, paddingForInfoType('Description', paddings)),
        customButtonParams: __assign({ options: {
                customButtonText: 'dummy-button-text'
            }, 
            // @ts-ignore
            horizontalAlignment: alignments.CustomButton }, paddingForInfoType('CustomButton', paddings)),
        socialParams: __assign({ viewMode: '', options: {
                galleryTextAlign: 'DUMMY',
                loveButton: true,
                allowSocial: true,
                loveCounter: false,
                allowDownload: true,
                hasThumbnails: false,
            }, 
            // @ts-ignore
            horizontalAlignment: alignments.Social }, paddingForInfoType('Social', paddings))
    };
}
function paddingForInfoType(iType, paddings) {
    // @ts-ignore
    var res = paddings[iType];
    return __assign({}, res);
}
function getRealMaster(order, enabled, alignments, paddings) {
    var orderCommaSeperated = __assign({}, order);
    // @ts-ignore
    orderCommaSeperated.top = order.top.join(',');
    // @ts-ignore
    orderCommaSeperated.middle = order.middle.join(',');
    // @ts-ignore
    orderCommaSeperated.bottom = order.bottom.join(',');
    return __assign(__assign({}, mockParams(alignments, paddings)), { "order": orderCommaSeperated, "enabled": {
            "Title": enabled.Title,
            "Description": enabled.Description,
            "Social": enabled.Social,
            "CustomButton": enabled.CustomButton
        } });
}
//# sourceMappingURL=masterInfoPanelUtils.js.map